var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1687 13.6667V19.9167C11.1687 20.1377 11.0809 20.3496 10.9247 20.5059C10.7684 20.6622 10.5565 20.75 10.3355 20.75C10.1146 20.75 9.90265 20.6622 9.74639 20.5059C9.59014 20.3496 9.50236 20.1377 9.50236 19.9167V15.6771L3.42018 21.7604C3.26465 21.9136 3.05524 21.9996 2.83696 22C2.61571 21.9991 2.40325 21.9133 2.24332 21.7604C2.0875 21.6042 2 21.3925 2 21.1719C2 20.9512 2.0875 20.7396 2.24332 20.5833L8.3255 14.5H4.08672C3.86575 14.5 3.65383 14.4122 3.49758 14.2559C3.34133 14.0996 3.25354 13.8877 3.25354 13.6667C3.25354 13.4457 3.34133 13.2337 3.49758 13.0774C3.65383 12.9211 3.86575 12.8333 4.08672 12.8333H10.3355C10.5565 12.8333 10.7684 12.9211 10.9247 13.0774C11.0809 13.2337 11.1687 13.4457 11.1687 13.6667ZM20.3336 2H6.16966C5.72772 2 5.30387 2.17559 4.99137 2.48816C4.67887 2.80072 4.50331 3.22464 4.50331 3.66667V8.66667C4.50331 8.88768 4.59109 9.09964 4.74734 9.25592C4.90359 9.4122 5.11551 9.5 5.33648 9.5C5.55746 9.5 5.76938 9.4122 5.92563 9.25592C6.08188 9.09964 6.16966 8.88768 6.16966 8.66667V3.66667H20.3336V17.8333H15.3346C15.1136 17.8333 14.9017 17.9211 14.7454 18.0774C14.5892 18.2337 14.5014 18.4457 14.5014 18.6667C14.5014 18.8877 14.5892 19.0996 14.7454 19.2559C14.9017 19.4122 15.1136 19.5 15.3346 19.5H20.3336C20.7756 19.5 21.1994 19.3244 21.5119 19.0118C21.8244 18.6993 22 18.2754 22 17.8333V3.66667C22 3.22464 21.8244 2.80072 21.5119 2.48816C21.1994 2.17559 20.7756 2 20.3336 2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/fullScreen.08da2eb5bb1e1525dae3b67268779c5d.svg";
export { ForwardRef as ReactComponent };